export default __webpack_public_path__ + "static/media/format-align-center.5f456432.svg";